import { render, staticRenderFns } from "./orderBooksDetail.vue?vue&type=template&id=97c0fc6a&"
import script from "./orderBooksDetail.vue?vue&type=script&lang=js&"
export * from "./orderBooksDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports